import NewsParagraph from "../components/NewsParagraph.tsx";
import ArticleContainer from "../components/ArticleContainer.tsx";

function Flash2() {
  return (
    <ArticleContainer>
      <NewsParagraph>
        Fabricated Climate Crisis Report Sparks International Uproar
      </NewsParagraph>
      <NewsParagraph>August 5, 2024</NewsParagraph>
      <NewsParagraph>
        GENEVA, SWITZERLAND (Reuters) – A climate crisis report, purportedly
        released by the Intergovernmental Panel on Climate Change (IPCC), has
        been exposed as a sophisticated fabrication created using advanced AI
        technology. The false report, which claimed that global temperatures
        would rise by 5°C within the next decade, triggered widespread panic and
        policy shifts before being debunked.
      </NewsParagraph>
      <NewsParagraph>
        The fabricated document, which mimicked the IPCC's formatting and
        writing style with uncanny accuracy, was distributed through what
        appeared to be official channels and was initially reported on by
        several major news outlets. It contained detailed but entirely fictional
        data, complete with convincing graphs and expert "quotations."
      </NewsParagraph>
      <NewsParagraph>
        "This represents a dangerous new frontier in misinformation," said Dr.
        Elena Patel, a genuine IPCC contributor. "The AI-generated content was
        so convincing that even experts were temporarily deceived. We need
        urgent measures to verify the authenticity of scientific communications
        in this new era."
      </NewsParagraph>
      <NewsParagraph>
        The incident has raised serious concerns about the potential for AI to
        undermine trust in scientific institutions and manipulate global policy
        decisions. Investigations are ongoing to identify those responsible for
        creating and distributing the fake report.
      </NewsParagraph>
    </ArticleContainer>
  );
}

export default Flash2;
